import { usersApi, userServices } from "@src/api/users";
import { labouringApi } from "@src/api/dictionaries/labouring";
import type { BootstrapContext } from "../types";

/**
 * Загружает current user с подразделениями/группами и labouring в bootstrap-контекст (без записи в stores).
 */
export async function loadUserData(ctx: BootstrapContext): Promise<void> {
    const briefUser = await usersApi.loadCurrent();
    const loadedUsers = await userServices.load({
        Codes: [briefUser.Code],
        Include: ["DivisionCodes", "GroupCodes"],
    });

    const user = loadedUsers[0];
    if (user == null) {
        throw new Error("Данные пользователя отсутствуют");
    }

    ctx.currentUser = user;

    if (user.LabourCode === 0) {
        ctx.labouring = null;
        return;
    }

    const labouringResult = await labouringApi.load({
        flt: { Codes: [user.LabourCode] },
    });

    const labouring = labouringResult.items[0];
    if (labouring == null) {
        throw new Error("Данные о работнике отсутствуют");
    }

    ctx.labouring = labouring;
}
